import { Backdrop, Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import CustomButton from '../../components/buttons/CustomButton';
import Breakdown from '../../../app/assets/images/breakdown.png';
import './LoginRedirect.scss';
import constant from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';

function LoginRedirect() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  let token = localStorage.getItem('token');
  let status = localStorage.getItem('status');

  const handleRedirect = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('status');
    navigate('/login');
  };

  useEffect(() => {
    if (!token || token === 'expired' || status === '401' || status === '403') {
      setIsOpen(true);
    }
  }, [token, status]);

  return (
    <Backdrop open={isOpen} sx={{ zIndex: 4000 }}>
      <Box className='private-box'>
        <Box component='img' src={Breakdown} className='image-box' />
        <Typography className='redirect-typo1'>
          {status === '403' ? `${constant.AccountDeactive}` : `${constant.Tokenexpired}`}
        </Typography>
        <Typography className='redirect-typo2'>
          {status === '403' ? constant.contactAdmin : constant.Loginagain}
        </Typography>
        <Box className='logout-align'>
          <CustomButton
            category='Go to Login'
            className='custom-button'
            onClick={handleRedirect}
          />
        </Box>
      </Box>
    </Backdrop>
  );
}

export default LoginRedirect;
